export default {
  name: "Nama",
  tel: "telefon",
  save: "jimat",
  confirm: "mengesahkan",
  cancel: "Batal",
  delete: "padam",
  complete: "Selesai",
  loading: "Memuatkan...",
  telEmpty: "Sila isi telefon",
  nameEmpty: "Sila isikan nama anda",
  nameInvalid: "请输入正确的姓名",
  confirmDelete: "确定要删除吗",
  telInvalid: "请输入正确的手机号",
  vanCalendar: {
    end: "Selesai",
    start: "mulakan",
    title: "pemilihan tarikh",
    confirm: "pasti",
    startEnd: "mula/tamat",
    weekdays: ["ahad", "pada Isnin", "Selasa", "Rabu", "Khamis", "hari jumaat", "Sabtu"],
    monthTitle: function monthTitle(year, month) {
      return year + "\u5E74" + month + "\u6708";
    },
    rangePrompt: function rangePrompt(maxRange) {
      return "\u9009\u62E9\u5929\u6570\u4E0D\u80FD\u8D85\u8FC7 " + maxRange + " \u5929";
    }
  },
  vanCascader: {
    select: "sila pilih"
  },
  vanContactCard: {
    addText: "添加联系人"
  },
  vanContactList: {
    addText: "新建联系人"
  },
  vanPagination: {
    prev: "halaman sebelumnya",
    next: "muka surat seterusnya"
  },
  vanPullRefresh: {
    pulling: "下拉即可刷新...",
    loosing: "释放即可刷新..."
  },
  vanSubmitBar: {
    label: "合计："
  },
  vanCoupon: {
    unlimited: "无使用门槛",
    discount: function discount(_discount) {
      return _discount + "\u6298";
    },
    condition: function condition(_condition) {
      return "\u6EE1" + _condition + "\u5143\u53EF\u7528";
    }
  },
  vanCouponCell: {
    title: "优惠券",
    tips: "暂无可用",
    count: function count(_count) {
      return _count + "\u5F20\u53EF\u7528";
    }
  },
  vanCouponList: {
    empty: "暂无优惠券",
    exchange: "兑换",
    close: "不使用优惠券",
    enable: "可用",
    disabled: "不可用",
    placeholder: "请输入优惠码"
  },
  vanAddressEdit: {
    area: "地区",
    postal: "邮政编码",
    areaEmpty: "请选择地区",
    addressEmpty: "请填写详细地址",
    postalEmpty: "邮政编码格式不正确",
    defaultAddress: "设为默认收货地址",
    telPlaceholder: "收货人手机号",
    namePlaceholder: "收货人姓名",
    areaPlaceholder: "选择省 / 市 / 区"
  },
  vanAddressEditDetail: {
    label: "详细地址",
    placeholder: "街道门牌、楼层房间号等信息"
  },
  vanAddressList: {
    add: "新增地址"
  }
};



// WEBPACK FOOTER //
// ./src/i18n/vant-locales/ms-MY.js